module.exports = __webpack_public_path__ + "img/folder.4783bda4.png";